import type { WorkflowStepCode } from '@exam-management/graphql';
import { Label, LabelColor, type LabelProps } from '@shared/components';

import { QSET_REVIEW_STATUS_COLOR, QSET_REVIEW_STATUS_TEXT } from './constants';

export interface QSetReviewStatusTagProps extends LabelProps {
  status: WorkflowStepCode;
}

export default function QSetReviewStatusTag(props: Readonly<QSetReviewStatusTagProps>) {
  const { status, ...restProps } = props;

  const statusKey = status as keyof typeof QSET_REVIEW_STATUS_COLOR;

  const color = QSET_REVIEW_STATUS_COLOR[statusKey] ?? LabelColor.GREY;
  const text = QSET_REVIEW_STATUS_TEXT[statusKey] ?? '-';

  return (
    <Label color={color} variant='outlined' {...restProps}>
      {text}
    </Label>
  );
}
